import React, { useState, useEffect, useRef } from 'react';

const CountdownClock = ({ expirationDateAcces }) => {
  const [timeRemaining, setTimeRemaining] = useState(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!expirationDateAcces) return;

    const updateTimeRemaining = () => {
      const now = Date.now();
      const expiration = expirationDateAcces.getTime();
      const secondsLeft = Math.max(0, Math.floor((expiration - now) / 1000));
      setTimeRemaining(prev => (prev !== secondsLeft ? secondsLeft : prev));
    };
    // Ejecutar al montar
    updateTimeRemaining();
    // Limpieza
    return () => clearInterval(intervalRef.current);
  }, [expirationDateAcces]);

  const formatTime = (seconds) => {
    const hrs = String(Math.floor(seconds / 3600)).padStart(2, '0');
    const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
    return `${hrs}:${mins}:00`;
  };

  return (
    <div className='tiempo-restante'>
      {formatTime(timeRemaining)}
    </div>
  );
};

export default CountdownClock;
